module.exports = __webpack_public_path__ + "static/media/SalmaAliandaScript-Regular.2f1e771a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SalmaAliandaScript-Regular.woff
// module id = 2439
// module chunks = 49